<div style="padding-top: 4px">
    <p-toast key="message"></p-toast>
    <p-steps [model]="items" [readonly]="true" [activeIndex]="activeIndex"
        (activeIndexChange)="onActiveIndexChange($event)"></p-steps>
</div>
<br />
<ng-container *ngIf="activeIndex === 0">

    <div>
        <div class="filter-container">
            <!-- Row 2: Select all, dropdowns, and clear all -->
            <div class="filter-row-2 flex align-items-end gap-3">
                <!-- Select All Checkbox -->
                <div class="search-container">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Search Staff" class="search-input"
                            (input)="queryData()" [(ngModel)]="staffSearchInput" appCapitalizeFirstLetter
                            appNoLeadingSpace />
                    </span>
                </div>
                <!-- Select Tag Dropdown -->
                <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2" optionLabel="name"
                    [(ngModel)]="selectedRoomId" filterBy="name" [showClear]="true" [options]="roomList"
                    optionValue="id" (onChange)="filterRoom()" [filter]="true" [placeholder]="'Select Classroom'"
                    #roomNameDropdown>
                </p-dropdown>

                <!-- Select Status Dropdown -->
                <p-multiSelect appendTo="body" class="custom-dropdown-filter mr-2 " optionLabel="name"
                    [(ngModel)]="selectedDesignation" filterBy="name" [options]="designationList" optionValue="name"
                    [filter]="true" placeholder="Select Designation" (onChange)="queryData()" #desigNameDropdown>
                </p-multiSelect>


                <!-- <button pButton type="button" 
         label="Clear All" 
         (click)="onClear()" 
         class="clear-btn"
         ></button> -->
            </div>
            <div class="filter-row-2 flex align-items-end gap-3">
                <div class=" field date-container">
                    <label for="fromDate" class="block text-sm ml-1 label opacity-50	 ">Start Date</label>
                    <input id="fromDate" type="date" pInputText placeholder="Start Date"
                        class="form-control search-input custom-input-filter" style="height: 62%;" [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="fromDate" [min]="todayDate" (change)="onClickDate('fromDate')" />
                </div>

                <div class="field date-container">
                    <label for="toDate" class="block text-sm ml-1 label opacity-50	">End Date</label>
                    <input id="toDate" type="date" pInputText placeholder="End Date" class="form-control search-input custom-input-filter"
                        style="height: 62%;" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" [min]="fromDate"
                        (change)="onClickDate('toDate')" />
                </div>
                <button pButton type="button" label="Clear All" (click)="onClear()" class="clear-btn"></button>

            </div>
            <div class="filter-row-3 flex align-items-center justify-content-between w-full py-2">
                <!-- Left side: Checkbox -->
                <div class="flex align-items-center gap-2">
                    <p-checkbox [binary]="true" [(ngModel)]="selectAllStaff"
                        (onChange)="toggleAllSelection();checkboxChanged()"></p-checkbox>
                    <label for="selectAll" class="mb-0">Select All</label>
                </div>

                <!-- Right side: Note -->
                <!-- <div class="note-container">
                    <div class="staff-profile-page__note--box">
                        <p class="p-2 m-0">Staffs will be refreshed on basis of date selection. Please select Date
                            first.</p>
                    </div>
                </div> -->
            </div>
        </div>

        <p-dataView [value]="staffList">
            <ng-template let-staff pTemplate="listItem">
                <div class="staff-item" [ngClass]="{ 'selected-staff': staff.selected }">
                    <img [src]="staff.profileimg"
                        class="border-circle border-2 border-primary inline-block profileImage mr-1"
                        alt="Place image title" *ngIf="
            staff.profileimg != null;
            else noImageFound
        " />
                    <ng-template #noImageFound>
                        <div class="circle flex justify-content-center align-items-center mr-1"
                            [style.background-color]="getBackgroundColor(staff.id)">
                            {{getInitials(staff.name)}}
                        </div>
                    </ng-template>

                    <span class="staff-name text-primary">{{ staff.name }}</span>
                    <p-checkbox [(ngModel)]="staff.selected" [value]="staff" (onChange)="
                toggleSelection(staff);
                isSelected(staff);
                checkboxChanged();" [binary]="true"></p-checkbox>
                </div>
            </ng-template>
            <ng-template pTemplate="empty">
                <div class="row" style="justify-content: center;">
                    <span class="text-primary text-center">
                        No result found
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <div class="flex align-items-center justify-content-center gap-3">
                    <button pButton pRipple type="button" label="Cancel" class="p-button-outlined"
                        (click)="ref.close()"></button>
                    <button pButton pRipple label="Continue" id="save" (click)="complete()"></button>
                </div>
            </ng-template>
        </p-dataView>


    </div>
</ng-container>

<ng-container *ngIf="activeIndex === 1">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="custom-staff-list">
                    <div class="custom-staff-card" *ngFor="let staff of selectedStaff">
                      <div class="custom-staff-row mb-3">
                        <!-- Staff Info (40%) -->
                        <div class="custom-staff-info">
                          <!-- Staff Profile Image -->
                          <img
                            *ngIf="staff.profileimg; else customNoImageFound"
                            [src]="staff.profileimg"
                            alt="staff Photo"
                            class="custom-staff-photo"
                          />
                          <ng-template #customNoImageFound>
                            <div class="circle flex justify-content-center align-items-center mr-1"
                            [style.background-color]="getBackgroundColor(staff.id)">
                            {{getInitials(staff.name)}}
                        </div>
                    </ng-template>
                  
                          <!-- staff Name -->
                          <span class="custom-staff-name">{{ staff.name }}</span>
                  
                          <!-- Delete Button -->
                          <button class="custom-delete-btn" (click)="onRemoveStaff($event, staff)">
                            <p-confirmPopup key="confirm2"></p-confirmPopup>
                            <i class="pi pi-trash"></i>
                          </button>
                        </div>
                  
                        <!-- Absent Notes (60%) -->
                        <div class="custom-absent-note">
                          <input type="text" class="custom-absent-note-input" placeholder="Enter Absent Notes" [(ngModel)]="staff.absentNote" />
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
    </div>
    <div class="flex align-items-center justify-content-center gap-3">
        <button pButton pRipple type="button" label="Go Back" class="p-button-outlined" (click)="prevPage()" [disabled]="fromOverView"></button>
        <button pButton pRipple label="Save" id="save" [disabled]="selectedStaff.length == 0"
            (click)="onSave()"></button>
    </div>

</ng-container>
